import React, { useEffect, useState } from 'react';
import { useParams, Link as RouterLink } from 'react-router-dom';
import { Box, Typography, Paper, Breadcrumbs, CircularProgress, Alert, Table, TableBody, TableCell, TableRow, Button } from '@mui/material';
import { apiService } from '../services/apiService';

const BounceDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [bounce, setBounce] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!id) return;
    setLoading(true);
    setError(null);
    apiService.getBounceDetail(Number(id))
      .then(res => setBounce(res.data))
      .catch(err => setError(err.message || 'Failed to load bounce'))
      .finally(() => setLoading(false));
  }, [id]);

  return (
    <Box sx={{ maxWidth: 900, mx: 'auto', mt: 4 }}>
      <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 2 }}>
        <RouterLink to="/app/contacts">Contacts</RouterLink>
        <RouterLink to="/app/contacts?tab=bounces">Bounces</RouterLink>
        <Typography color="text.primary">Bounce #{id}</Typography>
      </Breadcrumbs>
      <Paper sx={{ p: 4 }}>
        <Typography variant="h5" gutterBottom>Bounce Detail</Typography>
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
            <CircularProgress />
          </Box>
        ) : error ? (
          <Alert severity="error">{error}</Alert>
        ) : bounce ? (
          <Table>
            <TableBody>
              {Object.entries(bounce).map(([key, value]) => (
                <TableRow key={key}>
                  <TableCell sx={{ fontWeight: 600, width: 220 }}>{key}</TableCell>
                  <TableCell sx={{ wordBreak: 'break-all' }}>{typeof value === 'object' ? JSON.stringify(value, null, 2) : String(value)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        ) : null}
        <Box sx={{ mt: 3 }}>
          <Button component={RouterLink} to="/app/contacts?tab=bounces" variant="outlined">Back to Bounces</Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default BounceDetail; 